import { getDevtoolsLogMessage } from '../get-devtools-log-message';
export const createWebSpecificPropertiesSlice = (set, _get) => ({
    isDesktop: undefined,
    setIsDesktop: (isDesktop, extraDevtoolsInfo) => set((state) => {
        state.webSpecific.isDesktop = isDesktop;
    }, false, getDevtoolsLogMessage('setIsDesktop', extraDevtoolsInfo)),
});
